module.exports = __webpack_public_path__ + "media/spirit_of_ember.0b29034b.webm";